<template>
    <div>
        <div class="flex p-3 text-sm border rounded-md justify-between z-50 opacy-70" :class="alertClass" role="alert">
            <div class="flex items-center">
                <svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"></path>
                </svg>
                <div>
                    <span class="font-medium">{{ alertTitle }}</span>
                    {{ props.message }}
                </div>
            </div>
            <div>
                <button class="hover:bg-blue-300 p-0.5 rounded-md" @click="() => emits('close')">
                    <XMarkIcon class="w-5 h-5" />
                </button>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/solid';
import { AlertType } from '~/composables/alert';

const props = defineProps<{
    type: AlertType;
    message: string;
}>();
const emits = defineEmits<{
    (e: 'close'): void
}>();
const alertClass = computed(() => {
    return {
        "text-blue-800 border-blue-300 bg-blue-50": props.type === "info",
        "text-red-800 border-red-300 bg-red-50": props.type === "error",
        "text-green-800 border-green-300 bg-green-50": props.type === "success"
    }
})
const alertTitle = computed(() => {
    switch (props.type) {
        case "info": return "Info";
        case "error": return "Error";
        case "success": return "Success";
    }
})
</script>